import {
	Box,
	Button,
	Card,
	Flex,
	Heading,
	SimpleGrid,
	Stack,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
import { NAVIGATE } from 'constant/navigation';
import { useLocation, useNavigate } from 'react-router-dom';
import EducationLinks from 'views/client/education/components/EducationLinks';

export default function WhyCashback() {
	const textColor = useColorModeValue('gray.900', 'gray.100');
	const cardBg = useColorModeValue('gray.100', 'gray.500');
	const navigate = useNavigate();
	const location = useLocation();
	let isClient = false;
	if (location.pathname.includes('client')) isClient = true;

	return (
		<Box
			maxW={isClient ? '' : '900px'}
			alignSelf={isClient ? '' : 'center'}
			pt={isClient ? { base: '80px', md: '80px', xl: '80px' } : '0'}
		>
			<SimpleGrid
				mb='20px'
				columns={{ sm: 1, md: 1, lg: 1 }}
				spacing={{ base: '20px' }}
			>
				<Flex direction='column'>
					<Card bg={cardBg} mb={isClient ? '20px' : '50px'} p={6}>
						<Stack spacing={6}>
							<Heading size='md' color={textColor}>
								💡 ¿Cómo funciona el cashback en Bumbei?
							</Heading>
							<Text fontSize='md' color={textColor}>
								Cuando haces una compra desde Bumbei, la tienda nos paga una
								comisión por referirte como cliente. Es la misma inversión que
								harían en publicidad tradicional.
							</Text>
							<Text fontSize='md' color={textColor}>
								En vez de quedarnos con toda esa comisión, decidimos compartirla
								contigo como recompensa por tu compra, entregándola en Bitcoin
								para ayudarte a empezar tu camino en el mundo financiero
								digital.
							</Text>
							<Text fontSize='md' color={textColor}>
								Así, cada vez que compras, ganas sats —pequeñas fracciones de
								bitcoin— directamente en tu cuenta de Bumbei. Sin necesidad de
								comprar bitcoin, sin riesgo, solo por comprar como siempre.
							</Text>

							{isClient && (
								<Box pt={4}>
									<Button
										as='a'
										onClick={() => navigate(NAVIGATE.EDUCATION_CENTER)}
										variant='brand'
									>
										Volver al centro educativo
									</Button>
								</Box>
							)}
						</Stack>
					</Card>
					<EducationLinks current={'why-cashback'} isClient={isClient} />
				</Flex>
			</SimpleGrid>
		</Box>
	);
}
